<template>
  <main class="page news-page" v-if="$store.state.material">
    <div class="news-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'partitions'}">Деятельность</router-link>
        </li>
        <li class="breadcrumbs__item" v-if="$store.state.material.childnavigator.parent && $store.state.material.childnavigator.parent.parent">
          <router-link :to="{ name: 'partition', params: {id: $store.state.material.childnavigator.parent.parent.id }}">
            {{ $store.state.material.childnavigator.parent.parent.title }}
          </router-link>
        </li>
        <li class="breadcrumbs__item" v-if="$store.state.material.childnavigator.parent">
          <router-link :to="{ name: 'partition', params: {id: $store.state.material.childnavigator.parent.id }}">
            {{ $store.state.material.childnavigator.parent.title }}
          </router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'partition', params: {id: $store.state.material.childnavigator.id }}">{{ $store.state.material.childnavigator.title }}</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>{{ $store.state.material.name }}</span>
        </li>
      </ul>
      <img :alt="$store.state.material.name" class="news-page__image" :src="$store.state.material.img_articles | findSource($store.state.api)"/>
      <div class="news-page__article">
        <h1 class="news-page__title">{{ $store.state.material.name }}</h1>
        <div class="news-page__content" v-html="$store.state.material.content"></div>
      </div>
      <br/>
      <hr/>
      <br/>
      <div class="gallery-page__items" id="lightgallery" v-if="$store.state.material.big_img_articles && $store.state.material.big_img_articles.length">
        <a v-for="(photo, index) in $store.state.material.big_img_articles" :key="index" class="gallery-page__item" :href="photo | findSource2($store.state.api)" :title='$store.state.material.name' :aria-label='$store.state.material.name'>
          <img class="gallery__image" :src="photo | findSource2($store.state.api)" :alt='$store.state.material.name' @error="error"/>
        </a>
      </div>
      <div class="document-page__table" v-if="$store.state.material.get_documents && $store.state.material.get_documents.length">
        <div class="document-page__table__header">
          <span>Документы</span>
          <span>Дата публицации</span>
        </div>
        <ul class="document-page__table__body">
          <li class="document-page__table__item" v-for="(document, index) in $store.state.material.get_documents" :key="index">
            <a :href="document.document | findSourceDocument($store.state.api)" download>
              <h2 style="color: brown">{{ getDocumentName(document.document.url) }}</h2>
            </a>
            <time :datetime="document.date_publication | robotDate">{{ document.date_publication | humanDate }}</time>
          </li>
        </ul>
      </div>
      <div class="document-page__table document-page__table-articles" v-if="$store.state.material.child && $store.state.material.child.length">
        <div class="document-page__table__header">
          <span>Статьи</span>
          <span>Дата публицации</span>
        </div>
        <ul class="document-page__table__body">
          <li class="document-page__table__item" v-for="(child, index) in $store.state.material.child" :key="index">
            <router-link :to="{ path: child.url, params: { id: child.id }}">
              <h2>{{ child.name }}</h2>
            </router-link>
            <time :datetime="child.date_publication | robotDate">{{ child.date_publication | humanDate }}</time>
          </li>
        </ul>
      </div>
      <div class="news-page__share">
        <span class="news-page__share__title">Поделиться</span>
        <div class="news-page__share__buttons">
          <ShareNetwork :url="$store.state.path" description="Описание" media="/public/img/main.png" network="vk" title="Заголовок">
            <ShareVK/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" network="odnoklassniki" title="Заголовок">
            <ShareOK/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" network="twitter" title="Заголовок">
            <ShareTW/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" description="Описание" network="whatsapp" title="Заголовок">
            <ShareWH/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" description="Описание" network="telegram" title="Заголовок">
            <ShareTM/>
          </ShareNetwork>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import ShareFB from 'components/svg/ShareFB.vue'
import ShareVK from 'components/svg/ShareVK.vue'
import ShareOK from 'components/svg/ShareOK.vue'
import ShareWH from 'components/svg/ShareWH.vue'
import ShareTM from 'components/svg/ShareTM.vue'
import ShareTW from 'components/svg/ShareTW.vue'

export default {
  components: {
    ShareTW,
    ShareTM,
    ShareWH,
    ShareOK,
    ShareVK,
    ShareFB
  },
  async asyncData ({ store, host, route }) {
    store.state.path = `https://${host}${route.path}`
    await store.dispatch('PARTITIONS_SHOW_PAGE', route.params.id)
  },
  name: 'PartitionsShowPage',
  metaInfo () {
    return this.$store.state.material ? this.$seo(
      'common',
      this.$store.state.material.name,
      'управление образования, образование, администрация',
      this.$store.state.material.description,
      this.$store.state.material.name,
      this.$options.filters.findSource(this.$store.state.material.img_articles, this.$store.state.api),
      this.$store.state.material.description
    ) : this.$seo('common', '', '', '', '', '', '')
  },
  mounted () {
    require(['lightgallery.js'], () => {
      require(['lg-thumbnail.js'], () => {
        // eslint-disable-next-line no-undef
        lightGallery(document.getElementById('lightgallery'), {
          thumbnail: true
        })
      })
    })
  },
  methods: {
    error (e) {
      if (e.target.src !== '/public/img/gallery-placeholder.svg') e.target.src = '/public/img/gallery-placeholder.svg'
    },
    getDocumentName (document) {
      if (document.original_name) {
        return document.original_name
      } else {
        const needle = '/documents/documents/'
        if (document.indexOf(needle) !== -1) {
          return document.substr(document.indexOf(needle) + needle.length)
        } else {
          return document
        }
      }
    }
  }
}
</script>
